import { render, staticRenderFns } from "./actualitetitle.vue?vue&type=template&id=60825300&scoped=true&"
var script = {}
import style0 from "./actualitetitle.vue?vue&type=style&index=0&id=60825300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60825300",
  null
  
)

export default component.exports